enum CarouselLayoutEnum {
	default = 'default',
	/** @deprecated */
	theatre = 'theatre',
	overflow = 'overflow'
}

export default CarouselLayoutEnum;
